import { fetcher } from "helpers/fetcher";

import {
  TExportActiveVacanciesSummaryReq,
  TExportActiveVacanciesSummaryRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const exportActiveVacancySummary = async (
  payload?: TExportActiveVacanciesSummaryReq
) => {
  return await fetcher<
    TExportActiveVacanciesSummaryRes,
    TExportActiveVacanciesSummaryReq
  >(ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY_SUMMARY, {
    data: payload,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY_SUMMARY.version,
      [API_HEADER.CORP_ID]: payload?.idCorporation,
      [API_HEADER.BU_ID]: payload?.idBusinessUnit,
    },
  });
};

export const mutationExportActiveVacancySummary = async (
  payload?: TExportActiveVacanciesSummaryReq
) => {
  return (await exportActiveVacancySummary(payload)).data;
};

mutationExportActiveVacancySummary._key = (
  payload?: TExportActiveVacanciesSummaryReq
) => [ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY_SUMMARY.url, payload];
